export const NewOrdersHttpPaths = {
  recentShifts: '/recent-shifts',
  previousShifts: (clientCode: string) => `/previous-shifts/${clientCode}`,
} as const;
